import * as React from 'react';
import { Row, Col } from 'antd';
import { observer } from 'mobx-react';
import * as moment from "moment";

import { TabLanguageController } from 'src/core/ui/language/tab-language.controller';
import { DateView } from 'src/core/ui/date.view';
import { BooleanView } from 'src/core/ui/boolean.view';
import { ObjectUtils } from 'src/core/utils/object';

interface Props extends ComponentViewProps<TourItineraryDateItem> {
	mode: ControlMode;
	products: TourItineraryProductItem[];
	itinerary: TourItineraryItem;
}

@observer
export class TourItineraryDateGeneralTab extends React.Component<Props, {}> {
	render(): React.ReactNode {
		const { mode, model, setBusy, products } = this.props;
		const languageModels: TabLanguageModel[] = [
			{
				title: 'Title',
				dynamicProperties: model.dynamicProperties.displayName,
				required: true
			}
		];
		let minProduct: TourItineraryProductItem;
		let maxProduct: TourItineraryProductItem;
		let offset = 0;
		if (products && model.dateFrom) {
			for (const product of products) {
				if (minProduct == null || minProduct.dateFrom > product.dateFrom) {
					minProduct = product;
				}
				if (maxProduct == null || maxProduct.dateTo < product.dateTo) {
					maxProduct = product;
				}
			}
			offset = moment.utc(maxProduct.dateTo).diff(moment.utc(minProduct.dateFrom), "minute");
		}
		const dateTo = model.dateFrom == null ? null : moment.utc(model.dateFrom).add(offset, "minute").toDate();
		return (
			<React.Fragment>
				<Row gutter={16}>
					<Col xs={24} md={12}>
						<TabLanguageController
							dynamicProperties={languageModels}
							mode={mode}
							setBusy={setBusy}
							isRichTextBox={false}
						/>
					</Col>
				</Row>
				<Row gutter={16}>
					<Col xs={24} md={12}>
						<DateView
							required
							label="Date From"
							value={model.dateFrom}
							onChanged={(newValue) => {
								model.dateFrom = newValue;
							}}
							mode={mode}
							format="small-date"
							dateUsage="utc"
							disabledDate={this.disabledDate}
						/>
					</Col>
					<Col xs={24} md={12}>
						<DateView
							required
							label="Date To"
							value={dateTo}
							mode="display"
							format="small-date"
							dateUsage="utc"
						/>
					</Col>
				</Row>
				<Row gutter={16}>
					<Col xs={24} lg={12}>
						<BooleanView
							label="Commissionable"
							mode={mode}
							value={model.dynamicProperties.isCommissionable}
							onChanged={(newVal) => {
								model.dynamicProperties.isCommissionable = newVal;
							}}
						/>
					</Col>
					<Col xs={24} lg={12}>
						<BooleanView
							label="Reducible"
							mode={mode}
							value={model.dynamicProperties.isReducible}
							onChanged={(newVal) => {
								model.dynamicProperties.isReducible = newVal;
							}}
						/>
					</Col>
					<Col xs={24} lg={12}>
						<BooleanView
							label="Published"
							mode={mode}
							value={model.isPublished}
							onChanged={(newVal) => {
								model.isPublished = newVal;
							}}
						/>
					</Col>
				</Row>
			</React.Fragment>
		);
	}

	private disabledDate = (date: Date): boolean => {
		const { tourItinerary } = this.props.model;
		const weekdays: boolean[] = tourItinerary.dynamicProperties.weekdays;
		const dayOfWeek = moment.utc(date).weekday();
		return !weekdays[dayOfWeek === 0 ? 6 : dayOfWeek - 1];
	}
}



// WEBPACK FOOTER //
// ./src/app/products/tour-itineraries/tour-itinerary-date/form/parts/tour-itinerary-date-general-tab.tsx